import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { lang, locale } from '@/src/server/helpers/language'
import ca from './ca'
import en from './en'
import es from './es'
import fr from './fr'
import it from './it'
import pt from './pt'

Vue.use(VueI18n)

const messages = {
  ca,
  en,
  es,
  fr,
  it,
  pt,
}

document.querySelector('html').lang = lang()

export default new VueI18n({
  fallbackLocale: 'en',
  locale: locale(),
  messages: messages,
  silentTranslationWarn: true,
})



// WEBPACK FOOTER //
// ./src/server/i18n/index.js